import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const good = {
  createGood: lazyModuleMethod(() => import('./createGood'), 'default'),
  updateGood: lazyModuleMethod(() => import('./updateGood'), 'default'),
}
